import React from "react";

export default function RoundLoader() {
  return <img className="b2b-round-loader" src={`https://assets.airtel.in/static-assets/common/gif/loading-common.gif`} alt="loading..." />;
}
